module.exports = __webpack_public_path__ + "static/img/alarm_redg.351d4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alarm_redg.png
// module id = XCcE
// module chunks = 2